/**
 * FolderItem — card-style collapsible folder row.
 * Shows a green check mark when all docs in the folder have been accessed.
 */
import FileRow from './FileRow';

const FolderIcon = () => (
  <img src="/assets/images/pdp/folder.svg" alt="" width="20" height="20" aria-hidden="true" style={{ flexShrink: 0 }} />
);

const GreenCheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style={{ flexShrink: 0 }}>
    <circle cx="10" cy="10" r="10" fill="#00c950" />
    <path d="M6 10.5l2.5 2.5 5.5-5.5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronIcon = ({ open }) => (
  <svg
    width="14" height="14" viewBox="0 0 16 16" fill="none"
    xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
    className={`ddv-folder-chevron${open ? ' ddv-folder-chevron--open' : ''}`}
  >
    <path d="M4 6l4 4 4-4" stroke="#48525b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const FolderItem = ({ folderName, docs, isExpanded, isLocked, isComplete, fileErrors, onToggle, onFileActivate }) => {
  const hasDocs = Array.isArray(docs) && docs.length > 0;

  return (
    <div className={`ddv-folder-item${isLocked ? ' ddv-folder-item--locked' : ''}${isComplete ? ' ddv-folder-item--complete' : ''}`}>
      <div
        className="ddv-folder-header"
        role="button"
        tabIndex={isLocked ? -1 : 0}
        aria-expanded={isExpanded}
        onClick={onToggle}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onToggle(); } }}
      >
        <FolderIcon />
        <span className="ddv-folder-name">{folderName}</span>
        {isComplete && <GreenCheckIcon />}
        {hasDocs && !isLocked && !isComplete && <ChevronIcon open={isExpanded} />}
      </div>

      {isExpanded && hasDocs && (
        <div className="ddv-file-list">
          {docs.map((doc) => {
            const fileKey = doc.fileListId || doc.documentName;
            return (
              <FileRow
                key={fileKey}
                doc={doc}
                error={fileErrors instanceof Map ? (fileErrors.get(fileKey) ?? null) : null}
                onActivate={() => onFileActivate(doc)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FolderItem;
